import { render, staticRenderFns } from "./HttpDelete.vue?vue&type=template&id=5ed2f8c5&"
import script from "./HttpDelete.vue?vue&type=script&lang=ts&"
export * from "./HttpDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports